import { render, staticRenderFns } from "./markdown.component.vue?vue&type=template&id=347fb9aa&"
import script from "./markdown.component.vue?vue&type=script&lang=js&"
export * from "./markdown.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports